import InstructionsTable from '@/app/instructions'
import { ability } from '@/casl/ability'
import TableSkeleton from '@/components/table-skeleton'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { securityNotificationsQueryOptions } from '@/hooks/useSecurityNotificationsQuery'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <InstructionsTable />
}

export const Route = createFileRoute('/_auth/_withProject/instructions')({
  beforeLoad: ({ context }) => {
    if (ability && context.auth.user && !ability.can('read', 'Talimatlar')) {
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context

    await queryClient.prefetchQuery(securityNotificationsQueryOptions)
    return {}
  },
  pendingComponent: TableSkeleton,
  component: RouteComponent,
})


